import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import { NextDateProps } from './types';
import useNextDateViewModel from './useNextDateViewModel';

import styles from './index.module.scss';

const NextDate: FC<NextDateProps> = ({ selectedPriceItemPeriodTitle }) => {
  const viewModel = useNextDateViewModel();

  if (!viewModel) {
    return <div className={styles.skeleton} />;
  }

  const { hasTrialLicenses, licensesCount, formatNextBillingDate } = viewModel;

  return (
    <div className={styles.nextDateContainer}>
      <span>
        {TEXTS.TOTAL_PRICE_BLOCK_FIRST_DEBITING_TEXT(hasTrialLicenses, selectedPriceItemPeriodTitle.toLowerCase())}
      </span>
      &nbsp;
      <span data-testid="total_price_block_licenses_count">{licensesCount}</span>
      <span> {TEXTS.TOTAL_PRICE_BLOCK_FIRST_DEBITING_DATE(formatNextBillingDate)}</span>
    </div>
  );
};

export default React.memo(NextDate);
